export enum ProductionScheduleDrawingViewMode {
  DESIGNS = 'DESIGNS',
  DESIGNS_LIST = 'DESIGNS_LIST',
  ORDER_LINES = 'ORDER_LINES',
  GROUPED_ORDER_LINES = 'GROUPED_ORDER_LINES',
  GROUPED_DESIGNS = 'GROUPED_DESIGNS',
  GROUPED_DESIGN_THUMBNAILS = 'GROUPED_DESIGN_THUMBNAILS'
}
